module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aFucL"))).then(() => parcelRequire('cvs7o'));